import React from 'react';
import AdobePluginInstallInstructions from './adobe-plugin';
import type { IntegrationInstallInstructionsProps } from '@pages/AdminSettings/components/IntegrationTab/constants';

export default function PhotoshopInstallInstructions({
  organizationId,
  installed,
  onClose
}: IntegrationInstallInstructionsProps) {
  return (
    <AdobePluginInstallInstructions
      pluginType="photoshop"
      organizationId={organizationId}
      installed={installed}
      onClose={onClose}
    />
  );
}
